module.exports = __webpack_public_path__ + "media/src/components/CarInsurancePage/BuyReasonSection/affordable-premium-7e43f73a61cdde62ea4626fae12d4b69.png";